/* NEPO44 · LIFE — bounce the cart bubble whenever the count changes (independent of the cart JS). */
(function(){
  function bind(){
    document.querySelectorAll('.n44-cart-count').forEach(function(el){
      if(el.dataset.n44bump) return; el.dataset.n44bump='1';
      var mo=new MutationObserver(function(){
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
      mo.observe(el,{childList:true,characterData:true,subtree:true});
    });
  }
  if(document.readyState!=='loading') bind(); else document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
})();
